module.exports = __webpack_public_path__ + "static/media/cle-logo.11b01aac.png";